import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

const RunTimeField = ({
    value,
    onChange,
    label,
    disabled = false,
    required = false,
    error = false,
    textFieldProps = {},
    ...props
}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
                value={value}
                label={label}
                disabled={disabled}
                onChange={(newValue) => {
                    if (newValue === null || newValue?.isValid?.()) {
                        onChange?.(newValue);
                    }
                }}
                closeOnSelect={false}
                slotProps={{
                    textField: {
                        variant: "standard",
                        required,
                        error,
                        ...textFieldProps
                    }
                }}
                {...props}
            />
        </LocalizationProvider>
    );
};

export default RunTimeField